// Copyright (c) 2025 Deere & Company

import Dealer, {getDefaultState as getDealerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/dealer';
import t from 'tcomb';

const RgaDealerDetails = t.struct({
    analysisDate: t.Number,
    analysisResult: t.String,
    componentSerialNumber: t.String,
    dealerComments: t.String,
    dealerNumber: t.String,
    engineHours: t.Number,
    engineSerialNumber: t.String,
    followUpDate: t.Number,
    machineHours: t.Number,
    machineSerialNumber: t.String,
    model: t.String,
    partDescription: t.String,
    partNumber: t.String,
    processedDate: t.Number,
    requestedDate: t.Number,
    requestedPartQuantity: t.Number,
    requesterType: t.String,
    rgaDealer: t.maybe(Dealer),
    rgaNotes: t.String,
    rgaNumber: t.String,
    rgaRecallStatus: t.String,
    supplierAnalysis: t.String,
    supplierPartNumber: t.String,
    warrantyClaimNumber: t.String
}, {
    name: 'RgaDealerDetails',
    strict: true
});

export const getDefaultState = () => new RgaDealerDetails({
    analysisDate: 0,
    analysisResult: '',
    componentSerialNumber: '',
    dealerComments: '',
    dealerNumber: '',
    engineHours: 0,
    engineSerialNumber: '',
    followUpDate: 0,
    machineHours: 0,
    machineSerialNumber: '',
    model: '',
    partDescription: '',
    partNumber: '',
    processedDate: 0,
    requestedDate: 0,
    requestedPartQuantity: 0,
    requesterType: '',
    rgaDealer: getDealerDefaultState(),
    rgaNotes: '',
    rgaNumber: '',
    rgaRecallStatus: '',
    supplierAnalysis: '',
    supplierPartNumber: '',
    warrantyClaimNumber: ''
});

export default RgaDealerDetails;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/rga-dealer-details.js